module.exports = __webpack_public_path__ + "08a1820fb8f68f6e7ac70dc747575d5a.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/graviton_-_agudablack-webfont.woff
// module id = 1308
// module chunks = 28